module.exports = __webpack_public_path__ + "img/chart.4aceb68d.svg";